import { useState } from 'react';
import { Modal } from '@bluevision/components';
import type { SimpleFunc } from '@bluevision/tools';
import { useTranslation } from 'react-i18next';
import { useModel } from 'umi';
import { placeholder } from '@bluevision/tools';

import styles from './index.less';

interface EnterpriseInformationProps {
  onClose: SimpleFunc;
}

const EnterpriseInformation: React.FC<EnterpriseInformationProps> = ({ onClose }) => {
  const { t } = useTranslation();

  const [show, setShow] = useState(true);
  const { initialState } = useModel('@@initialState');
  const companyInfo = initialState?.currentUser?.companyInfo;

  // 结构
  const options = [
    {
      label: t('payment_company_name'),
      key: 'companyName',
    },
    {
      label: t('subject_of_party_b'),
      key: 'ourEntity',
    },
  ];

  return (
    <Modal
      open={show}
      title={t('enterprise_information')}
      onCancel={() => setShow(false)}
      afterClose={onClose}
      footer={null}
      maskClosable={false}
      size='small'
    >
      {options.map((option) => (
        <div className={styles.describe} key={option.key}>
          <div className={styles.label}>{option.label}</div>
          <div className={styles.content}>{companyInfo?.[option.key] || placeholder}</div>
        </div>
      ))}
    </Modal>
  );
};

export default EnterpriseInformation;
